import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Slider from "@mui/material/Slider";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import "./TruckDocs.scss";
import { Title } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import file from '../../../assets/images/file.png'
import pdf from '../../../assets/images/pdf.png'

function TruckDocs(props) {
  const { data, signature_sent } = useSelector((state) => state.data);
const openLink=(url)=>{
  if(url){
    window.open(url, '_blank')
  }
}

  const [titles, setTitles] = useState({
    inStockDate: "במלאי",
    shiabudRequestData: "בקשה לטופס שיעבוד",
    paymentDate: "תשלום",
    welcomeDate: "שיחת וולקום",
    hovaInsur: "ביטוח חובה",
    pdiDate: "PDI",
    buildingDate: "בונה ארגז",
    extraDate: "התקנות נוספות",
    Lic: "תהליך רישוי",
    qualtiCtrlDate: "בקרת איכות",
    deliveryAppoint: "תיאום מסירה",
    deliveryDate: "מסירה",
  });

  return (
    <Card className="uti-docs-box">
      <CardHeader title={"מסמכי משאית לצפייה"}></CardHeader>
      <CardContent>
        <div className="scroll_cont">
        <div className="docs_list">
        {data?.documents && data?.documents.map((doc)=>(
          <div onClick={()=>{openLink(doc.url ? doc.url : signature_sent?.filter(item => item.type === doc.documentType)[0]?.url)}} 
               className={`doc_item_row ${(doc.url ? doc.url : signature_sent?.filter(item => item.type === doc.documentType)[0]?.url) ? "active" : "disabled"}`}>
            <div className="first_row">
              <span className="bold_text">
                <img src={doc.url?file:pdf}></img>
                {doc.label}
                </span>
              <span className="doc_date">
                {signature_sent.some(item => item.type === doc.documentType) ? new Date().toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }) : 
                doc.date}
              </span>
            </div>
            <div className="signed">
              {signature_sent.some(item => item.type === doc.documentType) ? 'חתום' : doc.signed}
            </div>
          </div>)
        )}
        </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default TruckDocs;
